import "@/index.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "@/auth/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import Receipts from "@/pages/Receipts";
import ReceiptDetail from "@/pages/ReceiptDetail";
import AddReceipt from "@/pages/AddReceipt";
import Hauls from "@/pages/Hauls";
import HaulEdit from "@/pages/HaulEdit";
import Taxes from "@/pages/Taxes";
import MapPage from "@/pages/MapPage";
import Profile from "@/pages/Profile";
import Settings from "@/pages/Settings";
import Fleet from "@/pages/Fleet";
import Admin from "@/pages/Admin";
import Upgrade from "@/pages/Upgrade";
import UpgradeSuccess from "@/pages/UpgradeSuccess";
import SharePage from "@/pages/SharePage";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public bookkeeper share view — no auth, no app shell */}
          <Route path="/share/:token" element={<SharePage />} />

          {/* Auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* App (protected) */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/receipts" element={<Receipts />} />
              <Route path="/receipts/:id" element={<ReceiptDetail />} />
              <Route path="/add" element={<AddReceipt />} />
              <Route path="/hauls" element={<Hauls />} />
              <Route path="/hauls/:id" element={<HaulEdit />} />
              <Route path="/taxes" element={<Taxes />} />
              <Route path="/map" element={<MapPage />} />
              <Route path="/fleet" element={<Fleet />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/upgrade" element={<Upgrade />} />
              <Route path="/upgrade-success" element={<UpgradeSuccess />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
          </Route>

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster position="top-center" richColors theme="dark" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
